import { render, staticRenderFns } from "./ExpenseType.vue?vue&type=template&id=0ca71751&"
import script from "./ExpenseType.vue?vue&type=script&lang=js&"
export * from "./ExpenseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports